module.exports = __webpack_public_path__ + "static/assets/0043f23189fb3cbf2021a88959961ece.mp3";